import { installTailnetTransport } from './tailnetTransport';

/**
 * F-0821: imported first by the entry, so the transport is in place before any module creates an axios
 * instance (an instance copies `axios.defaults.adapter` when it is made) or keeps a reference to `fetch`.
 */
installTailnetTransport();
